import { Component, OnDestroy, computed, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { NbAccordionModule, NbIconModule, NbListModule } from "@nebular/theme";
import { CourseService } from "app/@core/services/course.service";
import { Course, Lesson, Module, NextStep } from "app/@core/types";
import { Subject } from "rxjs";

@Component({
  standalone: true,
  selector: "ngx-action-plan",
  styleUrls: ["./action-plan.component.scss"],
  templateUrl: "./action-plan.component.html",
  imports: [NbAccordionModule, NbIconModule, NbListModule],
})
export class ActionPlanComponent implements OnDestroy {
  private router = inject(Router);
  private courseService = inject(CourseService);

  private destroy$: Subject<void> = new Subject<void>();

  course = input.required<Course>();
  color = input<string>("");

  collapsed: boolean = false;
  lesson: Lesson;
  module: Module;

  nextSteps = computed<NextStep[]>(() => {
    const course = this.courseService.currentCourse();
    if (!course || course?.id === 0) return null;
    return this.course()
      .nextsteps.filter(
        (nextstep: NextStep) =>
          nextstep.end_date == "" || nextstep.end_date == null,
      )
      .slice(0, 3);
  });

  viewStep(course: Course, action: NextStep) {
    let modules = course.modules.concat(course.masterclasses);
    let module = modules.filter(
      (module: Module) => module.id == action.module_id,
    )[0];
    let lesson = module.lessons.filter(
      (lesson: Lesson) => lesson.id == action.lesson_id,
    )[0];
    this.router.navigate([
      "course",
      course.slug,
      "masterclasses",
      module.slug,
      lesson.slug,
    ]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
